const APIS = {
  DEFAULT_BRANCH: "/logisticservice/api/branch/default-branch/",
  STAFF: "/logisticservice/api/staff/",
  USER: "/logisticservice/api/user/",
  USER_PROFILE: "/logisticservice/api/user-profile/",
  CLIENT_TYPE: "/logisticservice/api/client-type/",
  LOCATION: "/logisticservice/api/location/",
  LOCATION_LIST: "/logisticservice/api/location/list/",
  SERVICE_TYPE: "/logisticservice/api/service-type/",
};

export default APIS;
